import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { AxiosInstance } from 'axios';
import { GeoZoneGroups } from '../../model';

export class GeoZoneGroupHttpController extends BaseHttpController<GeoZoneGroups> {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'geo-zone-group', client);
    }
}
